import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import debounce from 'lodash.debounce';
import axios from 'axios';
import { toast } from 'react-toastify';
import API from '../../../../../utils';

function PeopleAnalysis() {
    const [checkedValue, setCheckedValue] = useState({ people_analysis: '' });
    const [updatedTask, setUpdatedTask] = useState(null);
    const uid = localStorage.getItem("user_id");

    const fetchData = async () => {
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', uid);

            const response = await axios.post(`${API.BASE_URL}${API.ENDPOINTS.get_growth_people}`, formDataToSend, {
                headers: {
                    Authorization: `${API.AUTHORIZATION_TOKEN}`,
                },
            });

            if (response.data.status === "success") {
                setCheckedValue(response.data.data || { people_analysis: '' });
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Fetch meeting types error', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const debouncedUpdateTask = useCallback(
        debounce(async (task) => {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', uid);
            formDataToSend.append('analysis', task.value || '');

            try {
                const response = await axios.post(
                    `${API.BASE_URL}${API.ENDPOINTS.add_update_people_analysis}`,
                    formDataToSend,
                    {
                        headers: {
                            Authorization: `${API.AUTHORIZATION_TOKEN}`,
                        },
                    }
                );

                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    fetchData();
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                toast.error("An error occurred while updating data.");
            }
        }, 1000),
        [uid]
    );

    useEffect(() => {
        if (updatedTask) {
            debouncedUpdateTask(updatedTask);
        }
    }, [updatedTask, debouncedUpdateTask]);

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        // Update the state based on the checkbox value
        setCheckedValue({
            people_analysis: checked ? value : ''
        });

        // Set the updated task to trigger debounced update
        setUpdatedTask({
            value: checked ? value : ''
        });
    };

    return (
        <div className="col-sm-12">
            <div className="card mt-4">
                <div className="card-header">
                    <div className='justify-content-between d-flex'>
                        <div className="">
                            <h5>People Analysis</h5>
                        </div>
                        <div>
                            <Link className='backto-ondriver' to="/growthframeworks/founderdriver">Back to the Founder OS Drivers of Growth</Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="card-body">
                        <div className="founderdriers mb-3" style={{ backgroundColor: checkedValue.people_analysis === 'Enterprise' ? '#d3f9d8' : 'white' }}>
                            <p className="textnots-text">
                                <label><b>
                                    <input
                                        className="checkbox_animated"
                                        type="checkbox"
                                        value="Enterprise"
                                        checked={checkedValue.people_analysis === 'Enterprise'}
                                        onChange={handleCheckboxChange}
                                    />
                                    <strong>Maturity Level: Enterprise</strong>
                                </b></label>
                            </p>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • Purpose-driven organization with high performing teams focused on long-term value creation.
                                    </p>
                                    <p className="textnots-text">
                                        • The People Plan is fundamental to strategy.
                                    </p>
                                    <p className="textnots-text">
                                        • Strong and effective forward-looking human resource management.
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div className="founderdriers mb-3" style={{ backgroundColor: checkedValue.people_analysis === 'Corporation' ? '#d3f9d8' : 'white' }}>
                            <p className="textnots-text">
                                <label><b>
                                    <input
                                        className="checkbox_animated"
                                        type="checkbox"
                                        value="Corporation"
                                        checked={checkedValue.people_analysis === 'Corporation'}
                                        onChange={handleCheckboxChange}
                                    />
                                    <strong>Maturity Level: Corporation</strong>
                                </b></label>
                            </p>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • There is the flexibility and capability to meet the needs of an evolving business.
                                    </p>
                                    <p className="textnots-text">
                                        • The People Plan is fundamental to strategy.
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div className="founderdriers mb-3" style={{ backgroundColor: checkedValue.people_analysis === 'Startup' ? '#d3f9d8' : 'white' }}>
                            <p className="textnots-text">
                                <label><b>
                                    <input
                                        className="checkbox_animated"
                                        type="checkbox"
                                        value="Startup"
                                        checked={checkedValue.people_analysis === 'Startup'}
                                        onChange={handleCheckboxChange}
                                    />
                                    <strong>Maturity Level: Startup</strong>
                                </b></label>
                            </p>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • Management exhibits entrepreneurial spirit. Managers are hands-on and lead by example.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PeopleAnalysis;
